import { request } from "../lib/http";

export function fetchAll() {
  return request({
    url: "infractions-types",
    method: "get",
  });
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `infractions-types`,
    method: "get",
    params: queriesParams,
  });
}

export function addInfractionType(infractionType) {
  return request({
    method: "post",
    url: "infractions-types",
    data: infractionType,
  });
}

export function show(id) {
  return request({
    url: `infractions-types/${id}`,
    method: "get",
  });
}

export function edit(id, data) {
  return request({
    url: `infractions-types/${id}`,
    method: "patch",
    data,
  });
}
